import { get, post } from "./common/http";
import { BASE_URL } from "./common/const";
import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";


export const GetInvoiceReceiptDetail = (params: any) =>
   GET_ENC(`${BASE_URL}/api/InvoiceReceipt/GetDetail?` + params, null);

export const GetInvoiceReceiptList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/InvoiceReceipt/GetList?` + params, null);

export const GetInvoiceReceiptListBySupplier = (params: any) =>
   GET_ENC(`${BASE_URL}/api/InvoiceReceipt/GetListBySupplier?` + params, null);

export const CreateInvoiceReceipt = (data: any) =>
  POST_ENC(`${BASE_URL}/api/InvoiceReceipt/Create`, data);

export const UpdateInvoiceReceipt = (data: any) =>
  POST_ENC(`${BASE_URL}/api/InvoiceReceipt/Update`, data);

export const DeleteInvoiceReceipt = (data: any) =>
  POST_ENC(`${BASE_URL}/api/InvoiceReceipt/Delete`, data);

export const getInvoiceReceiptReportExportFile = (params: any) =>
   GET_ENC(`${BASE_URL}/api/InvoiceReceipt/InvoiceReceiptExportFile?` + params, null);

export const GetInvoiceReceiptNumber = (params: any) =>
   GET_ENC(`${BASE_URL}/api/InvoiceReceipt/GetInvoiceReceiptNumber?` + params, null);

export const CreateInvoiceReceiptBySale = (data: any) =>
  POST_ENC(`${BASE_URL}/api/InvoiceReceipt/CreateBySale`, data);


